// Sessiya ma'lumoti localStorage'da.
//
// NEGA localStorage, httpOnly cookie EMAS: xsib-admin bilan bir xil sabab —
// ilova backend bilan boshqa origin'da (subdomen) ishlashi mumkin.
//
// ⚠️ KALIT NOMI ADMIN PANELINIKIDAN ATAYLAB BOSHQA ("xsib-selfcare." prefiksi
// bilan, admin'da "xsib."). Ikkalasi bir brauzerda ochilishi mumkin — masalan
// operator o'z abonentligini ham shu qurilmadan tekshirsa. Kalitlar
// to'qnashsa, biri tokenini ikkinchisiga yozib, ikkalasini ham chalkashtirib
// qo'yardi.
const TOKEN_KEY = 'xsib-selfcare.token'
const EXPIRES_KEY = 'xsib-selfcare.expiresAt'

function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // localStorage yopiq bo'lsa sessiya faqat shu yorliqda yashaydi
  }
}

function remove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // e'tiborsiz
  }
}

export function getToken(): string | null {
  return read(TOKEN_KEY)
}

export function getExpiresAt(): string | null {
  return read(EXPIRES_KEY)
}

export function saveSession(token: string, expiresAt?: string | null): void {
  write(TOKEN_KEY, token)
  // Muddat berilmasa ESKISI O'CHIRILADI: qolib ketsa yangi sessiya eski
  // (allaqachon o'tgan) muddat bilan darhol "tugagan" deb hisoblanardi
  if (expiresAt) write(EXPIRES_KEY, expiresAt)
  else remove(EXPIRES_KEY)
}

export function clearSession(): void {
  remove(TOKEN_KEY)
  remove(EXPIRES_KEY)
}

/**
 * Token muddati o'tganmi.
 *
 * ⚠️ Token YO'Q bo'lsa `false` qaytaradi — "muddati o'tgan" va "umuman yo'q"
 * boshqa-boshqa holatlar. Chaqiruvchi (`client.ts`) ikkalasini alohida
 * tekshiradi.
 */
export function isTokenExpired(): boolean {
  const expiresAt = getExpiresAt()
  if (!expiresAt) return false
  const ts = Date.parse(expiresAt)
  return !Number.isNaN(ts) && ts <= Date.now()
}

/**
 * Token bormi va muddati o'tmaganmi.
 *
 * Bu FAQAT ortiqcha so'rov yubormaslik uchun — haqiqiy tekshiruv serverda.
 */
export function hasValidToken(): boolean {
  if (!getToken()) return false
  if (isTokenExpired()) {
    clearSession()
    return false
  }
  return true
}
